import { UserDetails } from "@/features/shared/types/user-interfaces";

/** Parties the logged-in user can act for: self plus each entry in `whoami.manages`. */
export type EditableUser = UserDetails;

export function getEditableUsers(whoami: EditableUser | null | undefined): EditableUser[] {
  const usersById = new Map<string, EditableUser>();
  const addUser = (user: EditableUser | null | undefined) => {
    if (!user?.id || usersById.has(user.id)) return;
    usersById.set(user.id, user);
  };
  addUser(whoami);
  whoami?.manages?.forEach(addUser);
  return Array.from(usersById.values());
}
